import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { S_Card } from '../../../../../design/card/card/S_Cards';
import { S_ClipLoader } from '../../../../../design/loaders/clipLoader/S_ClipLoader';
import { ConfirmationStatus, ResendStatus } from '../../containers/ConfirmEmailContainer';
import { ResendEmail } from './ResendEmail';

interface IProps {
  resendStatus: ResendStatus;
  confirmationStatus: ConfirmationStatus;
  onResendActivationEmailClick: () => Promise<void>;
  onGoToLoginClick: () => void;
}

export const ConfirmEmail = ({ resendStatus, confirmationStatus, onResendActivationEmailClick, onGoToLoginClick }: IProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <S_Card className='account-activation'>
      <div className='header'>
        {confirmationStatus === 'InProgress' && t('activating_account')}
        {confirmationStatus === 'Success' && t('activation_success')}
        {confirmationStatus === 'Failed' && t('activation_failed')}
      </div>
      <div className='content'>
        {confirmationStatus === 'InProgress' && (
          <S_ClipLoader
            color='var(--joy-palette-neutral-600)'
            size={48}
          />
        )}
        {confirmationStatus === 'Success' && (
          <div>
            <div className='auth-link'>
              {t('activation_success_description')}
              <a
                href='#'
                onClick={onGoToLoginClick}
              >
                {t('here')}
              </a>
              .
            </div>
          </div>
        )}
        {confirmationStatus === 'Failed' && t('activation_failed_description')}
      </div>
      {confirmationStatus !== 'Success' && (
        <ResendEmail
          onResendActivationEmailClick={onResendActivationEmailClick}
          resendStatus={resendStatus}
        />
      )}
    </S_Card>
  );
};
